import config from "src/config";

import { ResponseDto } from "src/dtos/common/responseDto";
import { EquipmentDto } from "src/dtos/equipment/equipmentDto";
import { getData } from "src/utils/axios/serverHelper";

const baseUrl = `${config.apiUrl}/Equipment`;

export const getEquipmentList = async () => {
	const url = `${baseUrl}/list`;
	return await getData<ResponseDto<EquipmentDto[]>>(url);
};

export const getEquipmentPopupList = async (searchText: string, equipmentType: string = '') => {
	const url = `${baseUrl}/modal`;
	return await getData<ResponseDto<EquipmentDto[]>>(url, {
		params: { searchText, equipmentType }
	});
};

export const getEquipmentPopupList_MetalMask = async (searchText: string = '') => {
	const url = `${baseUrl}/modal/metalMask`;
	return await getData<ResponseDto<EquipmentDto[]>>(url, {
		params: { searchText }
	});
};




